import { useCallback } from "react"
import { Link, useLocation } from "react-router-dom"

import useCollection from "areas/collection/hoc/use-collection"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import { trackSuperFiltersEvent } from "helpers/collection"

const SuperFilters = () => {
  const location = useLocation()
  const { data: { super_filters: superFilters } = {} } = useCollection()

  const sanitizeLinks = useCallback(
    (url) => {
      if (!url) return null

      if (url.startsWith("?")) {
        return `${location.pathname}${url}`
      } else if (!url.startsWith("http") && !url.startsWith("/")) {
        return `/${url}`
      }

      return url
    },
    [location.pathname]
  )

  if (!superFilters) return null

  return (
    <>
      <nav
        aria-label="Quick Filters"
        className="no-scrollbar desktop:flex-wrap desktop:justify-start desktop:overflow-x-auto desktop:overflow-y-auto desktop:gap-x-10 flex gap-x-6 gap-y-10 overflow-x-scroll whitespace-nowrap"
      >
        {superFilters.links.map((filter, index) => (
          <Button
            asChild
            className="border-grey-20 desktop:text-18 leading-25 inline-flex items-center rounded border px-20 font-bold focus-visible:-outline-offset-2"
            key={`${index}super_filter${filter.url}`}
            size="sm"
            variant="tertiary"
          >
            <Link
              data-lc="super-filters"
              onClick={() => {
                if (superFilters.type === "links") {
                  trackSuperFiltersEvent(location.pathname, filter.url)
                }
              }}
              to={sanitizeLinks(filter.url)}
            >
              {filter.name}
            </Link>
          </Button>
        ))}
      </nav>
      <Divider className="desktop:block mt-10 hidden" />
    </>
  )
}

export default SuperFilters
